import { HttpErrorResponse } from '@angular/common/http';

export class EnhanceYourCalmError extends Error {
    httpStatus = 420;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, EnhanceYourCalmError.prototype);
    }
}
